import { jsx } from 'react/jsx-runtime';
import ptbrLocale from 'date-fns/locale/pt-BR';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as DatePicker$1 } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';

const DatePicker = ({ label, value, handleChange, name, disabled, size = 'medium', }) => {
    return (jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterDateFns, locale: ptbrLocale, localeText: {
            cancelButtonLabel: 'Cancelar',
            clearButtonLabel: 'Limpar',
            todayButtonLabel: 'Hoje',
        } }, { children: jsx(DatePicker$1, { value: value, disabled: disabled, inputFormat: "dd/MM/yyyy", onChange: date => handleChange(date, name), renderInput: params => (jsx(TextField, Object.assign({}, params, { label: label, fullWidth: true, size: size, name: `${name}` }))), componentsProps: {
                actionBar: {
                    actions: ['today', 'clear', 'cancel'],
                },
            } }) })));
};

export { DatePicker };
